import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../composants/Button/Button';
import { ReactComponent as LogoIcon } from "../../assets/logo/logo-centralis-gris.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/view-more.svg";
import { ReactComponent as EyeSlashIcon } from "../../assets/icons/visibility-off.svg";
import CGVAccept from '../../composants/CGVAccept/CGVAccept';
import ValidationPopUp from '../../composants/ValidationPopUp/ValidationPopUp';
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg';
import './Register.css';
import OrganismeAutocomplete from '../../composants/OrganismeAutocomplete/OrganismeAutocomplete';
import Switch from '../../composants/Switch/Switch';
// FRONT-17: Import du nouveau composant de sélection des lots
import LotsSelectorInscription, { LotDepartementSelection } from './components/LotsSelectorInscription';

interface Organisme {
  id: number;
  nom: string;
}

interface IgnSuggestion {
  label: string;
  houseNumber?: string;
  street?: string;
  postcode?: string;
  city?: string;
}

// Ajouter cette nouvelle interface au début du fichier avec les autres interfaces
interface Entite {
  id: number;
  nom: string;
}

// FRONT-17: Les interfaces LotTechnique et Departement ne sont plus nécessaires ici
// Elles sont gérées dans LotsSelectorInscription

const Register: React.FC = () => {

  const [adresseInput, setAdresseInput] = useState('');
  const [adresseSuggestions, setAdresseSuggestions] = useState<IgnSuggestion[]>([]);
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  // État pour gérer les étapes : 0 = cards, 1 = acheteur, 2 = prestataire
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [isAcheteur, setIsAcheteur] = useState<null | boolean>(null);

  // Loguer les changements de currentStep
  useEffect(() => {
    console.log('[Register] currentStep changé :', currentStep);
  }, [currentStep]);

  // Loguer les changements de isAcheteur
  useEffect(() => {
    console.log('[Register] isAcheteur changé :', isAcheteur);
  }, [isAcheteur]);
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    confirm_email: '',
    password: '',
    password_confirmation: '',
    organisme: '',
    telephone: '',
    departement: '',
    code_postal: '',
    ville: '',
    prenom: '',
    acceptCGV: false,
    numero_voie: '',
    type_voie: '',
    nom_voie: '',
    siret: '',
  });



  const [error, setError] = useState('');
  const [cgvError, setCgvError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [organismeExists, setOrganismeExists] = useState<boolean | null>(null);
  const [organismeOptions, setOrganismeOptions] = useState<Organisme[]>([]);
  const [entiteOptions, setEntiteOptions] = useState<Entite[]>([]); // État pour les options d'entité
  const [entiteExists, setEntiteExists] = useState<boolean | null>(null);
  const [isEntiteSearchLoading, setIsEntiteSearchLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [entiteSearchTimeout, setEntiteSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [passwordValidation, setPasswordValidation] = useState({
    hasLowerCase: false,
    hasUpperCase: false,
    hasNumber: false,
    hasSpecialChar: false,
    isLongEnough: false,
    notEmail: true
  });
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [telError, setTelError] = useState('');
  const [isCGVModalOpen, setIsCGVModalOpen] = useState(false);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [successRedirectUrl, setSuccessRedirectUrl] = useState('/login');

  // Loguer l'ouverture de la modale CGV
  useEffect(() => {
    if (isCGVModalOpen) {
      console.log('[Register] Ouverture de la modale CGV');
    }
  }, [isCGVModalOpen]);
  const [isOrganismeSearchLoading, setIsOrganismeSearchLoading] = useState(false);
  const [siretPrestataire, setSiretPrestataire] = useState('');
  const [siretError, setSiretError] = useState('');
  const [siretExists, setSiretExists] = useState<boolean | null>(null);
  const [isSiretLoading, setIsSiretLoading] = useState(false);
  const [entrepriseEnFrance, setEntrepriseEnFrance] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const { login } = useAuth();
  const [prestataireSouscription, setPrestataireSouscription] = useState({
    entreprise: '',
    precision: '',
    pays: 'France',
    siret: siretPrestataire,
    rcs: '',
    statut_juridique: '',
    capital: '',
    date_creation: '',
    redressement_judiciaire: false,
    redressement: false,
    email: '',
    confirm_email: '',
    nom: '',
    prenom: '',
    fonction: '',
    telephone: '',
    accord_cadre: false,
    // Champs adresse
    adresse: '',
    code_postal: '',
    ville: '',
    // Champs mot de passe
    password: '',
    password_confirmation: '',
    // Acceptation des CGV
    acceptCGV: false,
  });

  // Etat pour les erreurs de validation prestataire
  const [prestataireEmailError, setPrestataireEmailError] = useState('');
  const [prestataireTelError, setPrestataireTelError] = useState('');
  const [dateCreationError, setDateCreationError] = useState('');

  // FRONT-17: État unifié pour les lots techniques et zones d'intervention
  // Remplace les anciens états selectedLotsTechniques et selectedDepartements
  const [selectedLotsDepartements, setSelectedLotsDepartements] = useState<LotDepartementSelection[]>([]);

  // États pour l'auto-complétion d'adresse prestataire
  const [adressePrestaInput, setAdressePrestaInput] = useState('');
  const [adressePrestaSuggestions, setAdressePrestaSuggestions] = useState<IgnSuggestion[]>([]);
  const debouncePrestaRef = useRef<NodeJS.Timeout | null>(null);
  const adressePrestaSelectedRef = useRef<boolean>(false); // Flag pour ignorer la recherche après sélection
  const adresseSelectedRef = useRef<boolean>(false); // Flag pour ignorer la recherche acheteur après sélection

  // FRONT-17: Le chargement des lots est maintenant géré par LotsSelectorInscription
  // Les anciens useEffect et handleDepartementToggle ont été supprimés

  // Effet pour rechercher l'organisme
  useEffect(() => {
    if (!formData.organisme || formData.organisme.length < 2) {
      setOrganismeOptions([]);
      return;
    }

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeoutId = setTimeout(() => {
      searchOrganisme(formData.organisme);
    }, 500);

    setSearchTimeout(timeoutId);

    return () => {
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, [formData.organisme]);

  // Vérification de la correspondance des mots de passe
  useEffect(() => {
    setPasswordsMatch(
      formData.password === formData.password_confirmation &&
      formData.password !== ''
    );
  }, [formData.password, formData.password_confirmation]);

  // Effet pour l'autocomplétion d'adresse IGN
  useEffect(() => {
    // Si on vient de sélectionner une adresse, ignorer cette recherche
    if (adresseSelectedRef.current) {
      adresseSelectedRef.current = false;
      return;
    }

    if (adresseInput.trim().length < 3) {
      setAdresseSuggestions([]);
      return;
    }

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const controller = new AbortController();

      fetch(`https://data.geopf.fr/geocodage/completion?text=${encodeURIComponent(adresseInput)}&index=StreetAddress&limit=8`,
        { signal: controller.signal })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(json => {
          console.log('IGN completion', json);
          if (json && json.results) {
            // Transformation des résultats dans le format IgnSuggestion
            const suggestions = json.results.map((result: any) => ({
              label: result.fulltext,
              houseNumber: result.kind === 'housenumber' ? result.fulltext.split(' ')[0] : '',
              street: result.street,
              postcode: result.zipcode,
              city: result.city
            }));
            console.log('Suggestions transformées:', suggestions);
            setAdresseSuggestions(suggestions);
          }
        })
        .catch((error) => {
          if (error.name !== 'AbortError') {
            console.error('Erreur lors de la récupération des adresses:', error);
          }
        });

      return () => controller.abort();
    }, 300);
  }, [adresseInput]);

  // Effet pour l'autocomplétion d'adresse IGN - PRESTATAIRE
  useEffect(() => {
    // Si on vient de sélectionner une adresse, ignorer cette recherche
    if (adressePrestaSelectedRef.current) {
      adressePrestaSelectedRef.current = false;
      return;
    }

    if (adressePrestaInput.trim().length < 3) {
      setAdressePrestaSuggestions([]);
      return;
    }

    if (debouncePrestaRef.current) clearTimeout(debouncePrestaRef.current);

    debouncePrestaRef.current = setTimeout(() => {
      const controller = new AbortController();

      fetch(`https://data.geopf.fr/geocodage/completion?text=${encodeURIComponent(adressePrestaInput)}&index=StreetAddress&limit=8`,
        { signal: controller.signal })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(json => {
          if (json && json.results) {
            const suggestions = json.results.map((result: any) => ({
              label: result.fulltext,
              houseNumber: result.kind === 'housenumber' ? result.fulltext.split(' ')[0] : '',
              street: result.street,
              postcode: result.zipcode,
              city: result.city
            }));
            setAdressePrestaSuggestions(suggestions);
          }
        })
        .catch((error) => {
          if (error.name !== 'AbortError') {
            console.error('Erreur lors de la récupération des adresses prestataire:', error);
          }
        });

      return () => controller.abort();
    }, 300);
  }, [adressePrestaInput]);

  // Fonction pour sélectionner une adresse depuis les suggestions IGN - PRESTATAIRE
  const handleSelectAdressePresta = (suggestion: IgnSuggestion) => {
    // Activer le flag pour ignorer la prochaine recherche
    adressePrestaSelectedRef.current = true;
    // Mise à jour des champs d'adresse prestataire
    setPrestataireSouscription(prev => ({
      ...prev,
      adresse: suggestion.street || suggestion.label,
      code_postal: suggestion.postcode || '',
      ville: suggestion.city || ''
    }));
    setAdressePrestaInput(suggestion.label);
    setAdressePrestaSuggestions([]);
  };

  // Fonction utilitaire pour détecter le type de voie
  const detectTypeVoie = (street?: string): string => {
    if (!street) return '';
    const s = street.toLowerCase();
    if (s.startsWith('rue')) return 'rue';
    if (s.startsWith('avenue')) return 'avenue';
    if (s.startsWith('boulevard')) return 'boulevard';
    if (s.startsWith('impasse')) return 'impasse';
    if (s.startsWith('allée')) return 'allée';
    if (s.startsWith('place')) return 'place';
    return '';
  };

  const searchOrganisme = async (query: string) => {
    setIsOrganismeSearchLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/organismes/autocomplete/${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      const data = await response.json();

      if (data.status === 'success' && Array.isArray(data.data)) {
        setOrganismeOptions(data.data);
        setOrganismeExists(data.data.length > 0);
      } else {
        setOrganismeOptions([]);
        setOrganismeExists(false);
      }
    } catch (error) {
      console.error('Erreur de recherche organisme:', error);
      setOrganismeOptions([]);
      setOrganismeExists(false);
    } finally {
      setIsOrganismeSearchLoading(false);
    }
  };

  // Ajouter cette fonction après la définition de searchOrganisme
  const searchEntite = async (query: string) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/entites/autocomplete/${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      const data = await response.json();

      if (data.status === 'success' && Array.isArray(data.data)) {
        // Traiter les suggestions d'entités ici
        const entites: Entite[] = data.data;
        // Mettre à jour l'état avec les suggestions d'entités
        setEntiteOptions(entites);
        setEntiteExists(entites.length > 0);
      } else {
        setEntiteOptions([]);
        setEntiteExists(false);
      }
    } catch (error) {
      console.error('Erreur de recherche entité:', error);
      setEntiteOptions([]);
      setEntiteExists(false);
    }
  };

  // Fonction de vérification du SIRET/numéro d'identification
  const verifySiret = async (siret: string) => {
    // Vérification du format selon le pays
    if (entrepriseEnFrance) {
      // France : SIRET de 14 chiffres
      if (siret.length !== 14 || !/^\d{14}$/.test(siret)) {
        setSiretError('Le SIRET doit contenir exactement 14 chiffres');
        setSiretExists(null);
        return;
      }
    } else {
      // Autres pays européens : numéro d'identification variable
      if (siret.length < 5 || siret.length > 20) {
        setSiretError('Le numéro d\'identification doit contenir entre 5 et 20 caractères');
        setSiretExists(null);
        return;
      }
    }

    setSiretError('');
    setIsSiretLoading(true);

    // Code pays pour l'API : FR pour France, EU pour autres pays européens
    const paysCode = entrepriseEnFrance ? 'FR' : 'EU';

    try {
      // Vérifier si le numéro d'identification existe déjà dans la base
      const response = await fetch(`${process.env.REACT_APP_API_URL}/entites/check-siret/${siret}?pays=${paysCode}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });

      const data = await response.json();

      if (data.status === 'success') {
        if (data.exists) {
          setSiretError(entrepriseEnFrance
            ? 'Ce SIRET est déjà enregistré sur Centralis. Veuillez vous connecter.'
            : 'Ce numéro d\'identification est déjà enregistré sur Centralis. Veuillez vous connecter.');
          setSiretExists(true);
        } else {
          setSiretExists(false);
          setSiretPrestataire(siret);
          setPrestataireSouscription(prevState => ({
            ...prevState,
            siret: siret
          }));
          // Passer à l'étape suivante
          setCurrentStep(3);
        }
      }
    } catch (error) {
      console.error('Erreur de vérification:', error);
      setSiretError(entrepriseEnFrance
        ? 'Erreur lors de la vérification du SIRET'
        : 'Erreur lors de la vérification du numéro d\'identification');
    } finally {
      setIsSiretLoading(false);
    }
  };

  const handleSiretChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (entrepriseEnFrance) {
      // France : uniquement des chiffres, max 14
      value = value.replace(/\D/g, '').slice(0, 14);
    } else {
      // Autres pays : alphanumériques autorisés, max 20
      value = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 20).toUpperCase();
    }
    setSiretPrestataire(value);
    setSiretError('');
    setSiretExists(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setCgvError('');
    setIsLoading(true);

    try {
      // Validation initiale
      if (isAcheteur === null) {
        throw new Error("Veuillez répondre à la question 'Êtes-vous un acheteur public?'");
      }

      // Vérification CGV uniquement pour les acheteurs (les prestataires ont la checkbox dans leur formulaire)
      if (isAcheteur && !formData.acceptCGV) {
        // Ouvrir le modal des CGV au lieu de lancer une erreur
        setIsCGVModalOpen(true);
        setCgvError("Vous devez lire et accepter les Conditions Générales pour vous inscrire.");
        setIsLoading(false);
        return;
      }

      if (isAcheteur) {
        // Logique pour les acheteurs
        if (organismeExists) {
          // Cas organisme existant

          // 1. Création de l'utilisateur
          const registerResponse = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({
              email: formData.email.toLowerCase(),
              password: formData.password,
              password_confirmation: formData.password_confirmation,
              telephone: formData.telephone,
              role: 'acheteur'
            }),
          });

          const registerData = await registerResponse.json();

          if (registerData.status !== 'success') {
            if (registerData.errors) {
              const firstErrorKey = Object.keys(registerData.errors)[0];
              if (firstErrorKey) {
                throw new Error(registerData.errors[firstErrorKey][0] || registerData.message);
              }
            }
            throw new Error(registerData.message || "Erreur lors de l'inscription");
          }

          // 2. Récupération de l'ID organisme
          const organismeSearchResponse = await fetch(`${process.env.REACT_APP_API_URL}/organismes/autocomplete/${formData.organisme}`);
          const organismeData = await organismeSearchResponse.json();

          if (organismeData.status !== 'success' || !organismeData.data.length) {
            throw new Error("Impossible de trouver l'organisme sélectionné");
          }

          const organismeId = organismeData.data[0].id;

          // 3. Création de l'entrée acheteur
          const acheteurResponse = await fetch(`${process.env.REACT_APP_API_URL}/acheteurs`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': `Bearer ${registerData.token}`
            },
            body: JSON.stringify({
              id_organisme: organismeId,
              id_user: registerData.user.id,
              nom: formData.nom,
              prenom: formData.prenom,
              telephone: formData.telephone,
              email_contact: formData.email.toLowerCase()
            }),
          });

          const acheteurData = await acheteurResponse.json();

          if (acheteurData.status !== 'success') {
            throw new Error(acheteurData.message || "Erreur lors de la création du profil acheteur");
          }

          // Succès final - FRONT-18: Ajout mention email vérification
          setSuccessMessage("Votre compte est en attente de validation par l'administrateur de votre organisme. Un email de vérification vous a été envoyé, veuillez le valider avant de vous connecter.");
          setSuccessRedirectUrl('/login');
          setIsSuccessPopupOpen(true);

        } else {
          // Cas nouvel organisme

          // Validation supplémentaire
          if (!formData.type_voie || !formData.nom_voie ||
            !formData.departement || !formData.code_postal || !formData.ville ||
            !formData.telephone || !formData.prenom) {
            throw new Error("Tous les champs sont obligatoires.");
          }

          // 1. Création de l'adresse
          const adresseResponse = await fetch(`${process.env.REACT_APP_API_URL}/adresses`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({
              numero_voie: formData.numero_voie,
              type_voie: formData.type_voie,
              nom_voie: formData.nom_voie,
              complement: '',
              code_postal: formData.code_postal,
              ville: formData.ville,
              departement: formData.departement,
              pays: 'France'
            }),
          });

          const adresseData = await adresseResponse.json();
          if (adresseData.status !== 'success') {
            throw new Error(adresseData.message || "Erreur lors de la création de l'adresse");
          }

          // 2. Création de l'organisme
          const organismeResponse = await fetch(`${process.env.REACT_APP_API_URL}/organismes`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({
              nom: formData.organisme,
              id_adresses: adresseData.data.id,
              siret: formData.siret,
              type: 'Public'
            }),
          });

          const organismeData = await organismeResponse.json();
          if (organismeData.status !== 'success') {
            throw new Error(organismeData.message || "Erreur lors de la création de l'organisme");
          }

          // 3. Inscription de l'utilisateur
          const registerResponse = await fetch(`${process.env.REACT_APP_API_URL}/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify({
              email: formData.email.toLowerCase(),
              password: formData.password,
              password_confirmation: formData.password_confirmation,
              telephone: formData.telephone,
              role: 'responsable_achat'
            }),
          });

          const registerData = await registerResponse.json();
          if (registerData.status !== 'success') {
            throw new Error(registerData.message || "Erreur lors de l'inscription");
          }

          // 4. Création du responsable d'achat
          const responsableResponse = await fetch(`${process.env.REACT_APP_API_URL}/responsables-achat`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': `Bearer ${registerData.token}`
            },
            body: JSON.stringify({
              id_organisme: organismeData.data.id,
              id_user: registerData.user.id,
              nom: formData.nom,
              prenom: formData.prenom,
              telephone: formData.telephone,
              email_contact: formData.email.toLowerCase()
            }),
          });

          const responsableData = await responsableResponse.json();
          if (responsableData.status !== 'success') {
            throw new Error(responsableData.message || "Erreur lors de la création du profil responsable d'achat");
          }

          // Succès final - FRONT-18: Ajout mention email vérification
          setSuccessMessage("Votre compte est en attente de validation par l'équipe Centralis. Un email de vérification vous a été envoyé, veuillez le valider avant de vous connecter.");
          setSuccessRedirectUrl('/login');
          setIsSuccessPopupOpen(true);
        }
      } else {
        // Logique pour les prestataires - Inscription complète via nouvelle API
        // Validations
        if (!prestataireSouscription.entreprise) {
          throw new Error("Le nom de l'entreprise est obligatoire.");
        }
        if (!prestataireSouscription.email) {
          throw new Error("L'email de l'administrateur est obligatoire.");
        }
        if (!prestataireSouscription.nom || !prestataireSouscription.prenom) {
          throw new Error("Le nom et prenom de l'administrateur sont obligatoires.");
        }
        if (prestataireSouscription.email !== prestataireSouscription.confirm_email) {
          throw new Error("Les adresses email ne correspondent pas.");
        }
        if (!prestataireSouscription.rcs) {
          throw new Error("Le numéro RCS est obligatoire.");
        }
        if (!prestataireSouscription.adresse || !prestataireSouscription.code_postal || !prestataireSouscription.ville) {
          throw new Error("L'adresse complète de l'entreprise est obligatoire.");
        }
        // FRONT-17: Validation adaptée pour le nouveau format
        if (selectedLotsDepartements.length === 0) {
          throw new Error("Veuillez sélectionner au moins un lot technique et une zone d'intervention.");
        }
        // Vérifier qu'il y a au moins une zone par lot technique sélectionné
        const lotsTechniquesIds = Array.from(new Set(selectedLotsDepartements.map(ld => ld.lot_technique_id)));
        if (lotsTechniquesIds.length === 0) {
          throw new Error("Veuillez sélectionner au moins un lot technique.");
        }
        if (!prestataireSouscription.acceptCGV) {
          throw new Error("Vous devez accepter les Conditions Générales d'Utilisation.");
        }

        // FRONT-17: Extraire les lots techniques et départements uniques depuis selectedLotsDepartements
        const uniqueLotsTechniques = Array.from(new Set(selectedLotsDepartements.map(ld => ld.lot_technique_id)));
        const uniqueDepartements = Array.from(new Set(selectedLotsDepartements.map(ld => ld.departement_id)));

        // Construire le payload selon le format attendu par RegisterPrestataireRequest
        const payload = {
          siret: siretPrestataire,
          entreprise: {
            nom: prestataireSouscription.entreprise,
            precision: prestataireSouscription.precision || null,  // FRONT-24: BUG FIX - Ajouter precision
            pays: entrepriseEnFrance ? 'FR' : 'EU',
            rcs: prestataireSouscription.rcs,
            statut_juridique: prestataireSouscription.statut_juridique || null,
            capital: prestataireSouscription.capital ? parseInt(prestataireSouscription.capital.replace(/\s/g, ''), 10) : null,
            date_creation: prestataireSouscription.date_creation ? `${prestataireSouscription.date_creation}-01-01` : null,
            redressement_judiciaire: prestataireSouscription.redressement || false,
            adresse: prestataireSouscription.adresse,
            code_postal: prestataireSouscription.code_postal,
            ville: prestataireSouscription.ville,
          },
          // FRONT-17: Utilise les valeurs extraites du nouveau format
          lots_techniques: uniqueLotsTechniques,
          departements: uniqueDepartements,
          // FRONT-17: Envoyer aussi le détail lot-département pour l'API
          lots_departements: selectedLotsDepartements.map(ld => ({
            lot_technique_id: ld.lot_technique_id,
            departement_id: ld.departement_id,
          })),
          administrateur: {
            nom: prestataireSouscription.nom,
            prenom: prestataireSouscription.prenom,
            email: prestataireSouscription.email.toLowerCase(),
            telephone: prestataireSouscription.telephone,
            // Pas de mot de passe - sera défini via email de confirmation
          },
          interesse_accord_cadre: prestataireSouscription.accord_cadre || false,
          accepte_cgu: true,
          accepte_confidentialite: true,
        };

        const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/register/prestataire`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (response.status === 409) {
          // SIRET déjà existant
          throw new Error(data.message || 'Ce SIRET est déjà enregistré.');
        }

        if (response.status === 422) {
          // Erreur de validation - Extraire les messages d'erreur lisibles
          const errors = data.errors;
          if (errors) {
            // Collecter toutes les erreurs dans un tableau
            const errorMessages: string[] = [];
            Object.entries(errors).forEach(([field, messages]) => {
              if (Array.isArray(messages)) {
                errorMessages.push(...messages);
              } else {
                errorMessages.push(String(messages));
              }
            });
            // Afficher toutes les erreurs séparées par des retours à la ligne
            throw new Error(errorMessages.join('\n'));
          }
          throw new Error(data.message || 'Erreur de validation.');
        }

        if (data.status !== 'success') {
          throw new Error(data.message || 'Une erreur est survenue lors de l\'inscription.');
        }

        // Inscription réussie - Afficher la popup de confirmation
        // FRONT-18: Message clair sur obligation de vérifier l'email + redirection vers /login
        setSuccessMessage("Votre inscription est réussie ! Un email de vérification vous a été envoyé. Veuillez valider votre adresse email avant de vous connecter.");
        setSuccessRedirectUrl('/login');
        setIsSuccessPopupOpen(true);
      }
    } catch (error) {
      console.error('Register error:', error);
      setError(error instanceof Error ? error.message : 'Une erreur est survenue lors de l\'inscription');
    } finally {
      setIsLoading(false);
    }
  };

  // Fonction pour vérifier le mot de passe en direct
  const validatePassword = (password: string) => {
    setPasswordValidation({
      hasLowerCase: /[a-z]/.test(password),
      hasUpperCase: /[A-Z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password),
      isLongEnough: password.length >= 8,
      notEmail: !/\S+@\S+\.\S+/.test(password) // Vérifie que le mot de passe n'est pas une adresse email
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === 'checkbox';

    let newValue = value;
    // For telephone field, remove non-digit characters and limit length to 10
    if (name === 'telephone') {
      newValue = value.replace(/\D/g, '');
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10);
      }
    }

    // Mise à jour de tous les champs du formulaire y compris acceptCGV
    setFormData(prev => ({
      ...prev,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : newValue
    }));

    // Valider le mot de passe en direct
    if (name === 'password') {
      validatePassword(value);
    }

    // Mettre à jour l'adresseInput quand un des champs d'adresse est modifié
    if (['numero_voie', 'type_voie', 'nom_voie', 'code_postal', 'ville'].includes(name)) {
      // Construire une nouvelle adresse formatée à partir des champs du formulaire
      const updatedFormData = {
        ...formData,
        [name]: value
      };

      const adresseFormatee = [
        updatedFormData.numero_voie,
        updatedFormData.type_voie,
        updatedFormData.nom_voie,
        updatedFormData.code_postal,
        updatedFormData.ville
      ].filter(Boolean).join(' ');

      setAdresseInput(adresseFormatee);
    }
  };

  const handlePrestataireSouscriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPrestataireSouscription(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSelectOrganisme = (organismeNom: string) => {
    setFormData(prev => ({ ...prev, organisme: organismeNom }));
    setOrganismeOptions([]);
    setOrganismeExists(true);
  };

  const handleSelectEntite = (entiteNom: string) => {
    setPrestataireSouscription(prev => ({ ...prev, entite: entiteNom }));
    setEntiteOptions([]);
    setEntiteExists(true);
  };

  // Nouveau: Sélection d'une adresse depuis les suggestions IGN
  const handleSelectAdresse = (suggestion: IgnSuggestion) => {
    // Activer le flag pour ignorer la prochaine recherche
    adresseSelectedRef.current = true;
    const type = detectTypeVoie(suggestion.street);
    let nomVoie = suggestion.street || '';

    // Retirer le type de voie du nom de la voie
    if (type && nomVoie) {
      // Nettoyer le nom de voie en retirant le type au début
      const typeRegex = new RegExp(`^${type}\\s+`, 'i');
      nomVoie = nomVoie.replace(typeRegex, '');
    }

    setFormData(prev => ({
      ...prev,
      numero_voie: suggestion.houseNumber || '',
      nom_voie: nomVoie,
      code_postal: suggestion.postcode || '',
      ville: suggestion.city || '',
      departement: suggestion.postcode ? suggestion.postcode.slice(0, 2) : '',
      type_voie: type
    }));

    setAdresseInput(suggestion.label);
    setAdresseSuggestions([]);
  };

  // Ajouter cette fonction au début du composant Register
  const fetchWithoutAuth = async (url: string, options: RequestInit = {}) => {
    // Assurez-vous que les en-têtes Authorization ne sont pas inclus
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...options.headers,
    };

    // Filtrer explicitement pour supprimer Authorization s'il existe
    delete (headers as any)['Authorization'];

    return fetch(url, {
      ...options,
      headers,
    });
  };

  const handleTelephoneBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const tel = formData.telephone;
    if (tel && !/^\d{10}$/.test(tel)) {
      setTelError("Le numéro de téléphone doit contenir exactement 10 chiffres.");
    } else {
      setTelError('');
    }
  };

  // Vérification de la correspondance des emails
  useEffect(() => {
    if (formData.confirm_email !== '' && formData.email !== formData.confirm_email) {
      setEmailError("Les adresses email ne correspondent pas.");
    } else {
      setEmailError('');
    }
  }, [formData.email, formData.confirm_email]);

  // Fonction pour obtenir les titres selon l'étape
  const getTitles = () => {
    switch (currentStep) {
      case 0:
        return {
          title: 'Inscription',
          subtitle: 'Choisissez votre type de compte'
        };
      case 1:
        // Étape 1 : Formulaire acheteur
        return {
          title: 'Inscription Acheteur',
          subtitle: 'Complétez les informations suivantes'
        };
      case 2:
        // Étape 2 : Vérification SIRET/numéro d'identification prestataire
        if (entrepriseEnFrance === null) {
          return {
            title: 'Localisation de l\'entreprise',
            subtitle: 'Indiquez où est située votre entreprise'
          };
        }
        return {
          title: entrepriseEnFrance ? 'Vérification du SIRET' : 'Vérification du numéro d\'identification',
          subtitle: entrepriseEnFrance
            ? 'Veuillez saisir votre numéro SIRET pour commencer votre inscription'
            : 'Veuillez saisir votre numéro d\'identification d\'entreprise'
        };
      case 3:
        // Étape 3 : Formulaire prestataire
        return {
          title: 'Inscription Prestataire',
          subtitle: 'Complétez les informations suivantes'
        };
      case 4:
        // Étape 4 : Confirmation prestataire
        return {
          title: 'Inscription réussie',
        }
      default:
        return {
          title: 'Inscription',
          subtitle: 'Choisissez votre type de compte'
        };
    }
  };

  const { title, subtitle } = getTitles();

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="logo-container">
          <LogoIcon className="logo" />
        </div>
        <h1>{title}</h1>

        <h2>{subtitle}</h2>

        {/* Afficher l'erreur en haut sauf pour l'étape 3 prestataire (l'erreur y est affichée en bas) */}
        {error && currentStep !== 3 && (
          <div className="error-message" style={{ whiteSpace: 'pre-line' }}>
            {error}
          </div>
        )}

        {/* Question Acheteur */}
        {/* <div className="form-group si-acheteur">
          <label>Êtes-vous un acheteur public ?<span style={{ color: 'red' }}>*</span></label>
          <div className="bouton-radio">
            <label>
              <input
                type="radio"
                name="isAcheteur"
                checked={isAcheteur === true}
                onChange={() => setIsAcheteur(true)}
                required
              />
              Oui
            </label>
            <label>
              <input
                type="radio"
                name="isAcheteur"
                checked={isAcheteur === false}
                onChange={() => setIsAcheteur(false)}
                required
              />
              Non
            </label>
          </div>
        </div> */}

        {/* {isAcheteur === false && (
          <div className="prestataire-section">
            <div className="info-message">
              <p>Vous ne pouvez pas vous inscrire si vous n'êtes pas un acheteur.</p>
              <p>Si vous êtes prestataire, les candidatures se font tous les deux ans. Pour être tenu au courant de notre prochaine phase de candidature, renseignez votre email :</p>
            </div>
            <form onSubmit={handleSubmit} className="prestataire-form">
              <div className="form-group">
                <label htmlFor="entite">Nom de l'entité<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  id="entite"
                  name="entite"
                  value={prestataireSouscription.entite}
                  onChange={handlePrestataireSouscriptionChange}
                  placeholder="Nom de votre entreprise"
                  required
                  autoComplete="off"
                  className="organisme-input"
                />
                <div className="icon-container">
                  {isEntiteSearchLoading ? (
                    <div className="search-loading"></div>
                  ) : (
                    <SearchIcon className="search-icon" />
                  )}
                </div>
                {entiteOptions.length > 0 && (
                  <ul className="autocomplete-list">
                    {entiteOptions.map(ent => (
                      <li key={ent.id} onClick={() => handleSelectEntite(ent.nom)}>
                        {ent.nom}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="email"
                  id="email-prestataire"
                  name="email"
                  value={prestataireSouscription.email}
                  onChange={handlePrestataireSouscriptionChange}
                  placeholder="exemple@entreprise.com"
                  required
                />
              </div>

              <div className="form-group cgv-container">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="acceptCGV"
                    checked={formData.acceptCGV}
                    onChange={handleChange}
                    required
                  />
                  <span>J'accepte les <a href="/cgv" target="_blank" rel="noopener noreferrer">Conditions Générales de Vente</a></span>
                </label>
              </div>

              <div className="form-actions">
                <Button
                  type="submit"
                  variant="primary"
                  value={isLoading ? "Souscription en cours..." : "S'inscrire"}
                  size="medium"
                  disabled={isLoading}
                />
              </div>
            </form>
          </div>
        )} */}
        {/* Deux cards (une acheteur et une prestataire ui ouvre le bon formulaire en fonction du clic) */}

        {currentStep === 0 && (
          <div className="account-type-cards">
            <div
              className={`account-type-card ${isAcheteur === true ? 'selected' : ''}`}
              onClick={() => {
                setIsAcheteur(true);
                setCurrentStep(1);
              }}
            >
              <div className="prestataire-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="#D97947" fill-opacity="0.1" />

                  <g transform="translate(1.5, 2)">
                    <path d="M46.6667 38.3333L50.0001 41.6667L56.6667 35" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M46.6666 55V51.6667C46.6666 49.8986 45.9642 48.2029 44.714 46.9526C43.4637 45.7024 41.768 45 39.9999 45H29.9999C28.2318 45 26.5361 45.7024 25.2859 46.9526C24.0356 48.2029 23.3333 49.8986 23.3333 51.6667V55" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M34.9999 38.3333C38.6818 38.3333 41.6666 35.3486 41.6666 31.6667C41.6666 27.9848 38.6818 25 34.9999 25C31.318 25 28.3333 27.9848 28.3333 31.6667C28.3333 35.3486 31.318 38.3333 34.9999 38.3333Z" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </svg>

              </div>
              <h3>Acheteur public</h3>
              <p>Accédez à l'annuaire des prestataires qualifiés et gérez vos commandes</p>
              <Button
                type="button"
                variant="primary"
                value="S'inscrire comme acheteur"
                size="small"
                onClick={() => {
                  setIsAcheteur(true);
                  setCurrentStep(1);
                }}
              />
            </div>
            <div
              className={`account-type-card ${isAcheteur === false ? 'selected' : ''}`}
              onClick={() => {
                setIsAcheteur(false);
                setCurrentStep(2);
              }}
            >
              {/* Icone */}
              <div className="prestataire-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="#D97947" fill-opacity="0.1" />

                  <g transform="translate(-1.5, -1.5)">
                    <path d="M36.6666 40H43.3333" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M36.6666 33.3333H43.3333" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M43.3333 55V50C43.3333 49.1159 42.9821 48.2681 42.357 47.643C41.7319 47.0178 40.884 46.6667 40 46.6667C39.1159 46.6667 38.2681 47.0178 37.6429 47.643C37.0178 48.2681 36.6666 49.1159 36.6666 50V55" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M30 36.6667H26.6667C25.7827 36.6667 24.9348 37.0178 24.3097 37.643C23.6846 38.2681 23.3334 39.1159 23.3334 40V51.6667C23.3334 52.5507 23.6846 53.3986 24.3097 54.0237C24.9348 54.6488 25.7827 55 26.6667 55H53.3334C54.2174 55 55.0653 54.6488 55.6904 54.0237C56.3155 53.3986 56.6667 52.5507 56.6667 51.6667V35C56.6667 34.1159 56.3155 33.2681 55.6904 32.643C55.0653 32.0178 54.2174 31.6667 53.3334 31.6667H50" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M30 55V28.3333C30 27.4493 30.3512 26.6014 30.9763 25.9763C31.6014 25.3512 32.4493 25 33.3333 25H46.6667C47.5507 25 48.3986 25.3512 49.0237 25.9763C49.6488 26.6014 50 27.4493 50 28.3333V55" stroke="#D97947" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                </svg>

              </div>
              <h3>Prestataire</h3>
              <p>Rejoigner Centralis et accédez aux marchés publics</p>
              <Button
                type="button"
                variant="primary"
                value="S'inscrire comme prestataire"
                size="small"
                onClick={() => {
                  setIsAcheteur(false);
                  setCurrentStep(2);
                }}
              />
            </div>
          </div>
        )}

        {/* Étape 2 : Vérification SIRET prestataire */}
        {currentStep === 2 && isAcheteur === false && (
          <div className="siret-verification-card">
            <div className="siret-card-content">
              <div className="siret-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="#D97947" fillOpacity="0.1" />
                  <g transform="translate(-1.5, -1.5)">
                    <path d="M36.6666 40H43.3333" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M36.6666 33.3333H43.3333" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M43.3333 55V50C43.3333 49.1159 42.9821 48.2681 42.357 47.643C41.7319 47.0178 40.884 46.6667 40 46.6667C39.1159 46.6667 38.2681 47.0178 37.6429 47.643C37.0178 48.2681 36.6666 49.1159 36.6666 50V55" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M30 36.6667H26.6667C25.7827 36.6667 24.9348 37.0178 24.3097 37.643C23.6846 38.2681 23.3334 39.1159 23.3334 40V51.6667C23.3334 52.5507 23.6846 53.3986 24.3097 54.0237C24.9348 54.6488 25.7827 55 26.6667 55H53.3334C54.2174 55 55.0653 54.6488 55.6904 54.0237C56.3155 53.3986 56.6667 52.5507 56.6667 51.6667V35C56.6667 34.1159 56.3155 33.2681 55.6904 32.643C55.0653 32.0178 54.2174 31.6667 53.3334 31.6667H50" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M30 55V28.3333C30 27.4493 30.3512 26.6014 30.9763 25.9763C31.6014 25.3512 32.4493 25 33.3333 25H46.6667C47.5507 25 48.3986 25.3512 49.0237 25.9763C49.6488 26.6014 50 27.4493 50 28.3333V55" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                </svg>
              </div>

              {/* Choix France ou UE */}
              {entrepriseEnFrance === null ? (
                <div className="pays-question-section">
                  <div className="form-group">
                    <label>Votre entreprise est-elle située en France ?<span style={{ color: 'red' }}>*</span></label>
                    <div className="pays-choice-buttons">
                      <button
                        type="button"
                        className="pays-choice-btn"
                        onClick={() => setEntrepriseEnFrance(true)}
                      >
                        <span className="flag-emoji">🇫🇷</span>
                        Oui, en France
                      </button>
                      <button
                        type="button"
                        className="pays-choice-btn"
                        onClick={() => setEntrepriseEnFrance(false)}
                      >
                        <span className="flag-emoji">🇪🇺</span>
                        Non, autre pays européen
                      </button>
                    </div>
                  </div>
                  <div className="siret-card-actions">
                    <Button
                      type="button"
                      className='back-button no-scale-button'
                      variant="secondary"
                      value="Retour"
                      size="small"
                      onClick={() => {
                        setCurrentStep(0);
                        setIsAcheteur(null);
                      }}
                    />
                  </div>
                </div>
              ) : (
                /* Saisie du numéro d'identification */
                <div className="siret-input-section">
                  <div className="form-group">
                    <label htmlFor="siret-prestataire">
                      {entrepriseEnFrance
                        ? <>Numéro SIRET<span style={{ color: 'red' }}>*</span></>
                        : <>Numéro d'identification européen<span style={{ color: 'red' }}>*</span></>
                      }
                    </label>
                    <input
                      type="text"
                      id="siret-prestataire"
                      name="siret"
                      value={siretPrestataire}
                      onChange={handleSiretChange}
                      placeholder={entrepriseEnFrance ? "12345678901234" : "Ex: BE0123456789"}
                      className={siretError ? 'input-error' : ''}
                      maxLength={entrepriseEnFrance ? 14 : 20}
                    />
                    <div className="siret-counter">
                      {entrepriseEnFrance
                        ? `${siretPrestataire.length} / 14 chiffres`
                        : `${siretPrestataire.length} caractères (5 à 20 max)`
                      }
                    </div>
                    {!entrepriseEnFrance && (
                      <div className="siret-info-text">
                        Saisissez le numéro d'identification de votre entreprise (TVA intracommunautaire, numéro d'entreprise, etc.)
                      </div>
                    )}
                    {siretError && <span className="error-message">{siretError}</span>}
                    {siretExists === false && (
                      <span className="success-message">✓ Numéro valide et disponible</span>
                    )}
                  </div>

                  <div className="siret-card-actions">
                    <Button
                      type="button"
                      className='back-button no-scale-button'
                      variant="secondary"
                      value="Retour"
                      size="small"
                      onClick={() => {
                        setEntrepriseEnFrance(null);
                        setSiretPrestataire('');
                        setSiretError('');
                        setSiretExists(null);
                      }}
                    />
                    <Button
                      type="button"
                      className='siret-check-button no-scale-button'
                      variant="primary"
                      value={isSiretLoading ? 'Vérification...' : 'Continuer'}
                      size="small"
                      onClick={() => verifySiret(siretPrestataire)}
                      disabled={isSiretLoading || (entrepriseEnFrance ? siretPrestataire.length !== 14 : siretPrestataire.length < 5)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Étape 3 : Complétez les informations suivantes prestataire */}
        {currentStep === 3 && isAcheteur === false && (
          <form onSubmit={handleSubmit}>
            <div className="prestataire-section">
              <div className="form-header-container">
                <div className="siret-icon">
                  <svg width="60" height="60" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="#D97947" fillOpacity="0.1" />
                    <g transform="translate(-1.5, -1.5)">
                      <path d="M36.6666 40H43.3333" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M36.6666 33.3333H43.3333" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M43.3333 55V50C43.3333 49.1159 42.9821 48.2681 42.357 47.643C41.7319 47.0178 40.884 46.6667 40 46.6667C39.1159 46.6667 38.2681 47.0178 37.6429 47.643C37.0178 48.2681 36.6666 49.1159 36.6666 50V55" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M30 36.6667H26.6667C25.7827 36.6667 24.9348 37.0178 24.3097 37.643C23.6846 38.2681 23.3334 39.1159 23.3334 40V51.6667C23.3334 52.5507 23.6846 53.3986 24.3097 54.0237C24.9348 54.6488 25.7827 55 26.6667 55H53.3334C54.2174 55 55.0653 54.6488 55.6904 54.0237C56.3155 53.3986 56.6667 52.5507 56.6667 51.6667V35C56.6667 34.1159 56.3155 33.2681 55.6904 32.643C55.0653 32.0178 54.2174 31.6667 53.3334 31.6667H50" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M30 55V28.3333C30 27.4493 30.3512 26.6014 30.9763 25.9763C31.6014 25.3512 32.4493 25 33.3333 25H46.6667C47.5507 25 48.3986 25.3512 49.0237 25.9763C49.6488 26.6014 50 27.4493 50 28.3333V55" stroke="#D97947" strokeWidth="3.33333" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                  </svg>
                </div>
                <div className='form-header'>
                  <h4>Informations entreprise</h4>
                  <p>Informations légales de votre entreprise</p>
                </div>
              </div>
              <div className="prestataire-form">

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="entreprise">Nom de l'entreprise<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="entreprise"
                      name="entreprise"
                      value={prestataireSouscription.entreprise}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Nom de votre entreprise"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="precision">Précision<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="precision"
                      name="precision"
                      value={prestataireSouscription.precision}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: (Agence Alpes Côte d'Azur)"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="pays">Pays<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="pays"
                      name="pays"
                      value={prestataireSouscription.pays}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: France, Belgique, Allemagne..."
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="siret">SIRET</label>
                    <input
                      type="text"
                      id="siret"
                      name="siret"
                      value={prestataireSouscription.siret}
                      disabled // Bloqué car vérifié à l'étape précédente
                      className="input-disabled"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="rcs">RCS<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="rcs"
                      name="rcs"
                      value={prestataireSouscription.rcs}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: RCS Paris 123 456 789"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="statut_juridique">Statut juridique<span style={{ color: 'red' }}>*</span></label>
                    <select
                      id="statut_juridique"
                      name="statut_juridique"
                      value={prestataireSouscription.statut_juridique}
                      onChange={(e: any) => handlePrestataireSouscriptionChange(e)}
                      required
                    >
                      <option value="">Sélectionnez...</option>
                      <option value="SAS">SAS</option>
                      <option value="SARL">SARL</option>
                      <option value="EURL">EURL</option>
                      <option value="SA">SA</option>
                      <option value="Auto-entrepreneur">Auto-entrepreneur</option>
                      <option value="Autre">Autre</option>
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="capital">Capital (€)<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="capital"
                      name="capital"
                      value={prestataireSouscription.capital}
                      onChange={(e) => {
                        // Formattage avec espaces pour les milliers
                        const rawValue = e.target.value.replace(/\D/g, '');
                        const formatted = new Intl.NumberFormat('fr-FR').format(Number(rawValue));
                        setPrestataireSouscription(prev => ({ ...prev, capital: rawValue === '' ? '' : formatted }));
                      }}
                      placeholder="Ex: 10 000"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="date_creation">Créée depuis (Année)<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="number"
                      id="date_creation"
                      name="date_creation"
                      min={1800}
                      max={new Date().getFullYear()}
                      value={prestataireSouscription.date_creation}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Limiter a 4 chiffres maximum
                        if (value.length <= 4) {
                          setPrestataireSouscription(prev => ({ ...prev, date_creation: value }));
                          // Effacer l'erreur pendant la saisie
                          if (dateCreationError) setDateCreationError('');
                        }
                      }}
                      onBlur={(e) => {
                        const year = parseInt(e.target.value, 10);
                        const currentYear = new Date().getFullYear();
                        if (e.target.value && (isNaN(year) || year < 1800 || year > currentYear)) {
                          setDateCreationError('Veuillez saisir une date valide');
                          setPrestataireSouscription(prev => ({ ...prev, date_creation: '' }));
                        } else {
                          setDateCreationError('');
                        }
                      }}
                      placeholder="Ex: 1980"
                      required
                      className={dateCreationError ? 'input-error' : ''}
                    />
                    {dateCreationError && <span className="error-message">{dateCreationError}</span>}
                  </div>
                </div>

                <div className="form-group redressement-switch redressement-section">
                  <div className="redressement-cadre-label-block">
                    <label htmlFor='redressement-switch' className="redressement-cadre-label">
                      Redressement judiciaire
                    </label>
                    <div className="redressement-cadre-description">
                      L'entreprise est-elle en redressement ?
                    </div>
                  </div>
                  {/* Redressement judiciaire switch */}
                  <div className="redressement-cadre-switch-control">
                    <Switch
                      id="redressement-switch"
                      isOn={!!prestataireSouscription.redressement}
                      handleToggle={e => setPrestataireSouscription(prev => ({ ...prev, redressement: e.target.checked }))}
                      onColor="#da7027"
                    />
                  </div>
                </div>

                {/* Champs d'adresse entreprise avec auto-complétion */}
                <div className="form-group adresse-autocomplete-container">
                  <label htmlFor="adresse-presta">Adresse<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    id="adresse-presta"
                    name="adresse_search"
                    value={adressePrestaInput}
                    onChange={(e) => {
                      setAdressePrestaInput(e.target.value);
                      // Si l'utilisateur tape manuellement, mettre à jour le champ adresse
                      setPrestataireSouscription(prev => ({ ...prev, adresse: e.target.value }));
                    }}
                    placeholder="Commencez à taper une adresse..."
                    autoComplete="off"
                  />
                  {adressePrestaSuggestions.length > 0 && (
                    <ul className="autocomplete-list adresse-suggestions">
                      {adressePrestaSuggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleSelectAdressePresta(suggestion);
                          }}
                          className="adresse-suggestion-item"
                        >
                          {suggestion.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="code_postal">Code postal<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="code_postal"
                      name="code_postal"
                      value={prestataireSouscription.code_postal}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: 75001"
                      maxLength={5}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="ville">Ville<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="ville"
                      name="ville"
                      value={prestataireSouscription.ville}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: Paris"
                      required
                    />
                  </div>
                </div>



              </div>
            </div>

            <div className="prestataire-section">
              <div className="form-header-container">
                <div className="siret-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#D97947" fill-opacity="0.1" />
                    <path d="M26.6667 18.3334C26.6667 22.4942 22.0508 26.8275 20.5008 28.1659C20.3564 28.2744 20.1807 28.3331 20 28.3331C19.8193 28.3331 19.6436 28.2744 19.4992 28.1659C17.9492 26.8275 13.3333 22.4942 13.3333 18.3334C13.3333 16.5652 14.0357 14.8696 15.2859 13.6193C16.5362 12.3691 18.2319 11.6667 20 11.6667C21.7681 11.6667 23.4638 12.3691 24.714 13.6193C25.9643 14.8696 26.6667 16.5652 26.6667 18.3334Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M20 20.8333C21.3807 20.8333 22.5 19.714 22.5 18.3333C22.5 16.9526 21.3807 15.8333 20 15.8333C18.6193 15.8333 17.5 16.9526 17.5 18.3333C17.5 19.714 18.6193 20.8333 20 20.8333Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </div>
                <div className='form-header'>
                  <h4>Référencement dans Centralis</h4>
                  <p>Sélectionnez vos domaines d'intervention</p>
                </div>
              </div>

              {/* FRONT-17: Nouveau composant de sélection des lots avec distinction régional/départemental */}
              <div className="prestataire-form">
                <LotsSelectorInscription
                  selectedLots={selectedLotsDepartements}
                  onChange={setSelectedLotsDepartements}
                  disabled={false}
                />
              </div>

            </div>

            <div className="prestataire-section">
              <div className="form-header-container">
                <div className="siret-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#D97947" fill-opacity="0.1" />
                    <path d="M25.8333 27.5V25.8333C25.8333 24.9493 25.4821 24.1014 24.857 23.4763C24.2319 22.8512 23.3841 22.5 22.5 22.5H17.5C16.616 22.5 15.7681 22.8512 15.143 23.4763C14.5179 24.1014 14.1667 24.9493 14.1667 25.8333V27.5" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M20 19.1667C21.841 19.1667 23.3333 17.6743 23.3333 15.8333C23.3333 13.9924 21.841 12.5 20 12.5C18.1591 12.5 16.6667 13.9924 16.6667 15.8333C16.6667 17.6743 18.1591 19.1667 20 19.1667Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>


                </div>
                <div className='form-header'>
                  <h4>Administrateur du compte</h4>
                  <p>Personne responsable du compte</p>
                </div>
              </div>

              <div className="prestataire-form">

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nom">Nom<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="nom"
                      name="nom"
                      value={prestataireSouscription.nom}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Nom"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="prenom">Prénom<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="prenom"
                      name="prenom"
                      value={prestataireSouscription.prenom}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Prénom"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="fonction">Fonction<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="fonction"
                      name="fonction"
                      value={prestataireSouscription.fonction}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="Ex: Directeur General"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="telephone">Téléphone<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="tel"
                      id="telephone"
                      name="telephone"
                      value={prestataireSouscription.telephone}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        setPrestataireSouscription(prev => ({ ...prev, telephone: value }));
                        if (prestataireTelError) setPrestataireTelError('');
                      }}
                      onBlur={(e) => {
                        const value = e.target.value;
                        if (value && !/^\d{10}$/.test(value)) {
                          setPrestataireTelError('Le numéro de téléphone doit contenir exactement 10 chiffres.');
                        } else {
                          setPrestataireTelError('');
                        }
                      }}
                      placeholder="Ex: 0123456789"
                      required
                      className={prestataireTelError ? 'input-error' : ''}
                    />
                    {prestataireTelError && <span className="error-message">{prestataireTelError}</span>}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={prestataireSouscription.email}
                      onChange={(e) => {
                        handlePrestataireSouscriptionChange(e);
                        // Valider la correspondance des emails si confirm_email est rempli
                        if (prestataireSouscription.confirm_email && e.target.value !== prestataireSouscription.confirm_email) {
                          setPrestataireEmailError('Les adresses email ne correspondent pas.');
                        } else {
                          setPrestataireEmailError('');
                        }
                      }}
                      placeholder="email@entreprise.fr"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirm_email_prestataire">Confirmer l'email<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      id="confirm_email_prestataire"
                      name="confirm_email"
                      value={prestataireSouscription.confirm_email}
                      onChange={(e) => {
                        setPrestataireSouscription(prev => ({ ...prev, confirm_email: e.target.value }));
                        // Valider la correspondance des emails
                        if (prestataireSouscription.email !== e.target.value) {
                          setPrestataireEmailError('Les adresses email ne correspondent pas.');
                        } else {
                          setPrestataireEmailError('');
                        }
                      }}
                      placeholder="Confirmez votre email"
                      required
                      className={prestataireEmailError ? 'input-error' : ''}
                    />
                    {prestataireEmailError && <span className="error-message">{prestataireEmailError}</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Section Intérêt Accord-Cadre */}
            {/* <div className="prestataire-section">
              <div className="form-header-container">
                <div className="siret-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#D97947" fill-opacity="0.1" />
                    <path d="M26.6667 13.3334H13.3333C12.4128 13.3334 11.6667 14.0795 11.6667 15V25C11.6667 25.9205 12.4128 26.6667 13.3333 26.6667H26.6667C27.5871 26.6667 28.3333 25.9205 28.3333 25V15C28.3333 14.0795 27.5871 13.3334 26.6667 13.3334Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M20 23.3333C21.841 23.3333 23.3333 21.841 23.3333 20C23.3333 18.1591 21.841 16.6667 20 16.6667C18.1591 16.6667 16.6667 18.1591 16.6667 20C16.6667 21.841 18.1591 23.3333 20 23.3333Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M15 13.3334V11.6667" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M25 13.3334V11.6667" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
                <div className='form-header'>
                  <h4>Intérêt Accord-Cadre</h4>
                  <p>Souhaitez-vous être informé de la prochaine session ?</p>
                </div>
              </div>

              <div className="prestataire-form">
                <div className="form-group accord-cadre-switch accord-cadre-section">
                  <div className="accord-cadre-label-block">
                    <label htmlFor='accord-cadre-switch' className="accord-cadre-label">
                      Intéressé par l'accord-cadre Centralis
                    </label>
                    <div className="accord-cadre-description">
                      L'accord-cadre vous permet de bénéficier de marchés publics facilités. 
                      Prochaine session d'attribution prévue prochainement.
                    </div>
                  </div>
                  <div className="accord-cadre-switch-control">
                    <Switch
                      id="accord-cadre-switch"
                      isOn={!!prestataireSouscription.accord_cadre}
                      handleToggle={e => setPrestataireSouscription(prev => ({ ...prev, accord_cadre: e.target.checked }))}
                      onColor="#da7027"
                    />
                  </div>
                </div>
              </div>
            </div> */}

            <div className="prestataire-section">
              <div className="form-header-container">
                <div className="siret-icon">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#D97947" fill-opacity="0.1" />
                    <path d="M15 28.3333C14.558 28.3333 14.134 28.1577 13.8215 27.8451C13.5089 27.5326 13.3333 27.1087 13.3333 26.6666V13.3333C13.3333 12.8913 13.5089 12.4673 13.8215 12.1548C14.134 11.8422 14.558 11.6666 15 11.6666H21.6667C21.9305 11.6662 22.1917 11.718 22.4354 11.8189C22.6791 11.9199 22.9005 12.0681 23.0867 12.255L26.0767 15.245C26.264 15.4312 26.4126 15.6527 26.5139 15.8968C26.6152 16.1408 26.6671 16.4024 26.6667 16.6666V26.6666C26.6667 27.1087 26.4911 27.5326 26.1785 27.8451C25.8659 28.1577 25.442 28.3333 25 28.3333H15Z" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M21.6667 11.6666V15.8333C21.6667 16.0543 21.7545 16.2663 21.9107 16.4225C22.067 16.5788 22.279 16.6666 22.5 16.6666H26.6667" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17.5 22.5L19.1667 24.1667L22.5 20.8334" stroke="#D97947" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>


                </div>
                <div className='form-header'>
                  <h4>Conditions Générales</h4>
                  <p>Acceptez les conditions d'utilisation</p>
                </div>
              </div>

              <div className="prestataire-form">

                <div className="form-group cgv-container">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="acceptCGV"
                      checked={!!prestataireSouscription.acceptCGV}
                      onChange={(e) => setPrestataireSouscription(prev => ({ ...prev, acceptCGV: e.target.checked }))}
                      required
                    />
                    <span>J'accepte les <a href="/cgv" target="_blank" rel="noopener noreferrer">Conditions Générales d'Utilisation</a><span style={{ color: 'red' }}>*</span></span>
                  </label>
                </div>

              </div>
            </div>

            {error && (
              <div className="error-message form-error" style={{ whiteSpace: 'pre-line' }}>
                {error}
              </div>
            )}

            <div className="form-actions-container">
              <Button
                type="button"
                variant="secondary"
                value="Retour"
                size="small"
                onClick={() => setCurrentStep(2)}
                className='back-button no-scale-button'
              />
              <Button
                type="submit"
                variant="primary"
                value={isLoading ? "Chargement..." : "Créer mon compte prestataire"}
                size="small"
                disabled={isLoading}
                className='informations-entreprise-button no-scale-button'
              />
            </div>
          </form>
        )}

        {/* Étape 4 : Validation d'inscription prestataire */}
        {currentStep === 4 && isAcheteur === false && (
          <div className="registration-success-card">
            <div className="success-icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z" fill="#DCFCE7" />
                <path d="M40 56.6667C49.2048 56.6667 56.6667 49.2048 56.6667 40C56.6667 30.7953 49.2048 23.3333 40 23.3333C30.7953 23.3333 23.3334 30.7953 23.3334 40C23.3334 49.2048 30.7953 56.6667 40 56.6667Z" stroke="#00A63E" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M35 40L38.3333 43.3333L45 36.6667" stroke="#00A63E" stroke-width="3.33333" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

            </div>
            <h3>Votre compte prestataire a été créé</h3>
            <p>
              Vous devez compléter votre profil avant de pouvoir utiliser Centralis.
              Veuillez renseigner toutes les informations obligatoires pour activer votre compte.
            </p>
            <Button
              type="button"
              variant="primary"
              value="Accéder à mon profil"
              size="small"
              onClick={() => window.location.href = '/profil'}
              className='profile-button no-scale-button'
            />
          </div>
        )}

        {/*   {isAcheteur === false && (
          <div className="prestataire-section">

            <form onSubmit={handleSubmit} className="prestataire-form">
              <div className="form-group">
                <label htmlFor="entite">Nom de l'entité<span style={{ color: 'red' }}>*</span></label>
                <div className="autocomplete-container">
                  <input
                    type="text"
                    id="entite"
                    name="entite"
                    value={prestataireSouscription.entite}
                    onChange={handlePrestataireSouscriptionChange}
                    placeholder="Nom de votre entreprise"
                    required
                    autoComplete="off"
                    className="organisme-input"
                  />
                  <div className="icon-container">
                    {isEntiteSearchLoading ? (
                      <div className="search-loading"></div>
                    ) : (
                      <SearchIcon className="search-icon" />
                    )}
                  </div>
                  {entiteOptions.length > 0 && (
                    <ul className="autocomplete-list">
                      {entiteOptions.map(ent => (
                        <li key={ent.id} onClick={() => handleSelectEntite(ent.nom)}>
                          {ent.nom}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>

              <div className="utilisateur-section">
                <h3>Informations du contact</h3>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nom-prestataire">Nom<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="nom-prestataire"
                      name="nom"
                      value={prestataireSouscription.nom || ''}
                      onChange={(e) => setPrestataireSouscription(prev => ({ ...prev, nom: e.target.value }))}
                      placeholder="Votre nom"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="prenom-prestataire">Prénom<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="prenom-prestataire"
                      name="prenom"
                      value={prestataireSouscription.prenom || ''}
                      onChange={(e) => setPrestataireSouscription(prev => ({ ...prev, prenom: e.target.value }))}
                      placeholder="Votre prénom"
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email-prestataire">Email<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      id="email-prestataire"
                      name="email"
                      value={prestataireSouscription.email}
                      onChange={handlePrestataireSouscriptionChange}
                      placeholder="exemple@entreprise.com"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="confirm_email-prestataire">Confirmer l'email<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="email"
                      id="confirm_email-prestataire"
                      name="confirm_email"
                      value={prestataireSouscription.confirm_email || ''}
                      onChange={(e) => setPrestataireSouscription(prev => ({ ...prev, confirm_email: e.target.value }))}
                      placeholder="Confirmez votre email"
                      required
                      className={prestataireSouscription.email !== prestataireSouscription.confirm_email && prestataireSouscription.confirm_email ? 'input-error' : ''}
                    />
                    {prestataireSouscription.email !== prestataireSouscription.confirm_email && prestataireSouscription.confirm_email &&
                      <span className="error-message">Les adresses email ne correspondent pas.</span>
                    }
                  </div>
                  <div className="form-group">
                    <label htmlFor="telephone-prestataire">Téléphone<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="tel"
                      id="telephone-prestataire"
                      name="telephone"
                      value={prestataireSouscription.telephone || ''}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(/\D/g, '');
                        if (newValue.length <= 10) {
                          setPrestataireSouscription(prev => ({ ...prev, telephone: newValue }))
                        }
                      }}
                      placeholder="06 23 00 00 00"
                      required
                    />
                  </div>
                </div>
              </div>

              {cgvError && <div className="cgv-error">{cgvError}</div>}

              <div className="form-actions-container">
                <button
                  type="button"
                  className="cgv-view-button"
                  onClick={() => setIsCGVModalOpen(true)}
                >
                  Accepter les CGV
                </button>

                <Button
                  type="submit"
                  variant="primary"
                  value={isLoading ? "Souscription en cours..." : "S'inscrire"}
                  size="medium"
                  disabled={isLoading || !formData.acceptCGV}
                  className="submit-button"
                />
              </div>
            </form>
          </div>
        )} */}

        {/* Formulaire pour les acheteurs */}
        {currentStep === 1 && isAcheteur === true && (
          <form onSubmit={handleSubmit} className="acheteur-form acheteur-section">
            {/* Choix de l'organisme */}
            <div className="form-group">
              <label htmlFor="organisme">
                Organisme<span style={{ color: 'red' }}>*</span>
              </label>
              <div className="autocomplete-container">
                <input
                  type="text"
                  id="organisme"
                  name="organisme"
                  value={formData.organisme}
                  onChange={handleChange}
                  placeholder="Nom de votre organisme"
                  required
                  autoComplete="off"
                  className="organisme-input"
                />
                <div className="icon-container">
                  {isOrganismeSearchLoading ? (
                    <div className="search-loading"></div>
                  ) : (
                    <SearchIcon className="search-icon" />
                  )}
                </div>
                {organismeOptions.length > 0 && (
                  <ul className="autocomplete-list">
                    {organismeOptions.map(org => (
                      <li key={org.id} onClick={() => handleSelectOrganisme(org.nom)}>
                        {org.nom}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* <OrganismeAutocomplete
              value={formData.organisme}
              onChange={(val) => setFormData({ ...formData, organisme: val })}
              onSelect={(org) => setFormData({ ...formData, organisme: org.nom })}
              organismeOptions={organismeOptions}
              isLoading={isOrganismeSearchLoading}
            /> */}

            {/* Champs supplémentaires si l'organisme n'existe pas */}
            {organismeExists === false && (
              <div className="nouveau-organisme-section">
                <h3>Informations sur l'organisme</h3>

                <div className="form-group">
                  <label htmlFor="siret">SIRET<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    id="siret"
                    name="siret"
                    value={formData.siret || ''}
                    onChange={handleChange}
                    placeholder="Ex : 12345678901234"
                    required
                    pattern="^\d{14}$"
                    maxLength={14}
                    minLength={14}
                    title="Le SIRET doit comporter exactement 14 chiffres"
                  />
                </div>
                {/* Champ d'autocomplétion d'adresse IGN */}
                <div className="form-group">
                  <label htmlFor="adresse-autocomplete">Recherche d'adresse<span style={{ color: 'red' }}>*</span></label>
                  <div className="autocomplete-container">
                    <input
                      type="text"
                      id="adresse-autocomplete"
                      value={adresseInput}
                      onChange={(e) => setAdresseInput(e.target.value)}
                      placeholder="Saisissez l'adresse pour l'autocompléttion"
                      autoComplete="off"
                    />
                    {adresseSuggestions.length > 0 && (
                      <ul className="autocomplete-list" role="listbox">
                        {adresseSuggestions.map((suggestion, index) => (
                          <li
                            key={index}
                            role="option"
                            onClick={() => handleSelectAdresse(suggestion)}
                          >
                            {suggestion.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="departement">Département<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="departement"
                      name="departement"
                      value={formData.departement}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="code_postal">Code postal<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="code_postal"
                      name="code_postal"
                      value={formData.code_postal}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="ville">Ville<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="ville"
                      name="ville"
                      value={formData.ville}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="numero_voie">Numéro</label>
                    <input
                      type="text"
                      id="numero_voie"
                      name="numero_voie"
                      value={formData.numero_voie}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="type_voie">Type de voie<span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="type_voie"
                      name="type_voie"
                      value={formData.type_voie}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="nom_voie">Nom de la voie<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    id="nom_voie"
                    name="nom_voie"
                    value={formData.nom_voie}
                    onChange={handleChange}
                    required
                  />
                </div>


              </div>
            )}

            {/* Informations de l'utilisateur (titre modifié en fonction de l'existence de l'organisme) */}
            <div className="utilisateur-section">
              <h3>{organismeExists === true ? "Informations de l'utilisateur" : "Informations du responsable du compte"}</h3>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="nom">Nom<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder="Votre nom"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="prenom">Prénom<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    id="prenom"
                    name="prenom"
                    value={formData.prenom}
                    onChange={handleChange}
                    placeholder="Votre prénom"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="exemple@email.com"
                    required
                  />
                </div>
                {/* Champ de confirmation d'email */}
                <div className="form-group">
                  <label htmlFor="confirm_email">Confirmer l'email<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="email"
                    id="confirm_email"
                    name="confirm_email"
                    value={formData.confirm_email}
                    onChange={handleChange}
                    placeholder="Confirmez votre email"
                    required
                    className={emailError ? 'input-error' : ''}
                  />
                  {emailError && <span className="error-message">{emailError}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="telephone">Téléphone<span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    placeholder="06 23 00 00 00"
                    required
                    onBlur={handleTelephoneBlur}
                    className={telError ? 'input-error' : ''}
                  />
                  {telError && <span className="error-message">{telError}</span>}
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Mot de passe<span style={{ color: 'red' }}>*</span></label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Entrez votre mot de passe"
                    required
                    minLength={6}
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                  </button>
                </div>
                <div className="password-requirements">
                  <p>Le mot de passe doit contenir :</p>
                  <ul>
                    <li className={passwordValidation.hasLowerCase ? 'valid' : 'invalid'}>Une minuscule</li>
                    <li className={passwordValidation.hasUpperCase ? 'valid' : 'invalid'}>Une majuscule</li>
                    <li className={passwordValidation.hasNumber ? 'valid' : 'invalid'}>Un chiffre</li>
                    <li className={passwordValidation.hasSpecialChar ? 'valid' : 'invalid'}>Un caractère spécial</li>
                    <li className={passwordValidation.isLongEnough ? 'valid' : 'invalid'}>Au moins 8 caractères</li>
                    <li className={passwordValidation.notEmail ? 'valid' : 'invalid'}>Ne doit pas être une adresse email</li>
                  </ul>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password_confirmation">Confirmer le mot de passe<span style={{ color: 'red' }}>*</span></label>
                <div className="password-input-container">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="password_confirmation"
                    name="password_confirmation"
                    value={formData.password_confirmation}
                    onChange={handleChange}
                    placeholder="Confirmez votre mot de passe"
                    required
                    minLength={6}
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <EyeSlashIcon /> : <EyeIcon />}
                  </button>
                </div>
                {!passwordsMatch && formData.password_confirmation !== '' && (
                  <div className="error-message">
                    Les mots de passe ne correspondent pas.
                  </div>
                )}
              </div>
            </div>

            {cgvError && <div className="cgv-error">{cgvError}</div>}

            <div className="form-group cgv-container">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="acceptCGV"
                  checked={!!formData.acceptCGV}
                  onChange={handleChange}
                  required
                />
                <span>J'accepte les <a href="/cgv" target="_blank" rel="noopener noreferrer">Conditions Générales d'Utilisation</a><span style={{ color: 'red' }}>*</span></span>
              </label>
            </div>

            <div className="form-actions-container">
              {/* Back button */}

              <Button
                type="button"
                className='back-button no-scale-button'
                variant="secondary"
                value="Retour"
                size="small"
                onClick={() => {
                  setCurrentStep(0);
                  setIsAcheteur(null);
                  setOrganismeExists(null);
                  setFormData(prev => ({
                    ...prev,
                    organisme: '',
                    siret: '',
                    departement: '',
                    code_postal: '',
                    ville: '',
                    numero_voie: '',
                    type_voie: '',
                    nom_voie: '',
                  }));
                }}
              />

              <Button
                type="submit"
                variant="primary"
                value={isLoading ? "Inscription en cours..." : "S'inscrire"}
                size="small"
                disabled={isLoading || !formData.acceptCGV}
                className="submit-button"
              />
            </div>
          </form>
        )}

        {/* Modal d'affichage des CGV */}
        <CGVAccept
          acceptCGV={formData.acceptCGV}
          setAcceptCGV={(newAccept: boolean) =>
            setFormData(prev => ({ ...prev, acceptCGV: newAccept }))
          }
          isOpen={isCGVModalOpen}
          onClose={() => setIsCGVModalOpen(false)}
          onConfirm={() => {
            // Lorsque l'utilisateur confirme l'acceptation des CGV
            setFormData(prev => ({ ...prev, acceptCGV: true }));
            setIsCGVModalOpen(false);
          }}
          className="cgv-modal-large"
        />

        {/* Popup de succès d'inscription */}
        <ValidationPopUp
          isOpen={isSuccessPopupOpen}
          title="Inscription réussie !"
          text={successMessage}
          onClose={() => {
            setIsSuccessPopupOpen(false);
            navigate(successRedirectUrl);
          }}
          onConfirm={() => {
            setIsSuccessPopupOpen(false);
            navigate(successRedirectUrl);
          }}
          confirmLabel="Compris"
        />

        <div className="register-footer">
          <p className="login-link">
            Déjà inscrit ? <Link to="/login">Se connecter</Link>
          </p>
        </div>
      </div>
    </div >
  );
};

export default Register;